<template>
  <div v-if="isOpen" v-bind="$attrs" :class="$style['info-modal']">
    <div :class="$style.content">
      <v-card>
        <v-card-title v-if="headline" :class="$style.headline">{{ headline }}</v-card-title>

        <v-card-text v-if="message">{{ message }}</v-card-text>

        <v-card-actions>
          <v-btn
            type="button"
            :class="$style.button"
            outlined
            rounded
            :elevation="0"
            @click.native="isOpen = false"
            >{{ $t('account.account-address.form-button-ok') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headline: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Replace with 'true' to display the Functionality Info before login when on mobile view
      isOpen: false,
    }
  },
}
</script>

<style lang="scss" module>
.info-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 251;

  &:before {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 250;

    background-color: rgba(25, 25, 25, 0.6);

    content: '';
  }
}

.content {
  position: fixed;
  top: 50%;
  z-index: 252;

  max-width: 400px;
  margin: 0 1rem;

  transform: translateY(-50%);
}

.button {
  color: var(--white) !important;

  background-color: var(--primary);
  border-color: var(--white) !important;

  &:global(.v-btn) {
    height: 30px !important;

    font-size: var(--font-base) !important;
  }
}

.headline {
  font-weight: bold;
}
</style>
